export default __webpack_public_path__ + "a10eac3f0ffd6a652c7d43539222435b.svg";